// defined in vite.config.ts
declare const __API_URL__: string;

export const API_URL = __API_URL__;
